<template>
  <div class="listpanel-container">
    <div class="listpanel-container__header">
      <slot name='header'></slot>
    </div>
    <el-tabs type="border-card" class="custom-card" v-bind="$attrs">
      <el-tab-pane :label="title">
        <slot></slot>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'yblListPanel',
  props: {
    title: {
      type: String,
      default: function () {
        return '列表'
      }
    }
  },
  mounted () {
    const _this = this
    this.$nextTick(() => {
      _this.resize()

      _this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('resize', _this.resize, false)
      })
      window.addEventListener('resize', _this.resize, false)
    })
  },
  methods: {
    resize () {
      const el = this.$el
      const element = el.querySelector('.custom-card .is-active')
      if (element) {
        const width = element.clientWidth
        let panelWidth = el.clientWidth
        if (+width > 0) {
          el.querySelector('.listpanel-container__header').style.width = `${panelWidth - width - 40}px`
          el.querySelector('.listpanel-container__header').style.left = `${width + 10}px`
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.listpanel-container {
  position: relative;
  margin: 20px auto;
  &__header {
    position: absolute;
    width: 80%+5%;
    z-index: 200;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    left: 18%-5%;
    min-height: 40px;
    height: 40px;
    .item {
      padding: 0 5px;
      margin-right: 10px;
    }
  }
}
@media only screen and (min-width: 1450px) {
  .listpanel-container {
    &__header {
      width: 89%;
      left: 10%;
    }
  }
}
@media only screen and (max-width: 1200px) {
  .listpanel-container {
    &__header {
      width: 80%;
      left: 18%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ListPanel.vue